import { createContext, useContext, useEffect, useState } from "react";
import http from "../api/http";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(() => localStorage.getItem("lainternacional_token"));
  const [usuario, setUsuario] = useState(() => {
    const raw = localStorage.getItem("lainternacional_user");
    try {
      return raw ? JSON.parse(raw) : null;
    } catch {
      localStorage.removeItem("lainternacional_user");
      return null;
    }
  });
  const [verificando, setVerificando] = useState(() => Boolean(localStorage.getItem("lainternacional_token")));

  const limpiarSesion = () => {
    localStorage.removeItem("lainternacional_token");
    localStorage.removeItem("lainternacional_user");
    setToken(null);
    setUsuario(null);
  };

  useEffect(() => {
    let activo = true;

    const validarSesion = async () => {
      if (!token) {
        setVerificando(false);
        return;
      }

      try {
        const { data } = await http.get("/auth/me");
        if (!activo) return;
        if (data.usuario) {
          localStorage.setItem("lainternacional_user", JSON.stringify(data.usuario));
          setUsuario(data.usuario);
        }
      } catch {
        if (activo) limpiarSesion();
      } finally {
        if (activo) setVerificando(false);
      }
    };

    validarSesion();
    return () => {
      activo = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  useEffect(() => {
    const handleExpired = () => limpiarSesion();
    window.addEventListener("lainternacional:auth-expired", handleExpired);
    return () => window.removeEventListener("lainternacional:auth-expired", handleExpired);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const guardarSesion = (data) => {
    if (!data.token || !data.usuario) throw new Error("Sesion incompleta.");
    localStorage.setItem("lainternacional_token", data.token);
    localStorage.setItem("lainternacional_user", JSON.stringify(data.usuario));
    setToken(data.token);
    setUsuario(data.usuario);
    setVerificando(true);
  };

  const login = async ({ usuario: nombreUsuario, password }) => {
    limpiarSesion();
    const { data } = await http.post("/auth/login", {
      usuario: nombreUsuario,
      password,
    });
    if (data.token && data.usuario) {
      guardarSesion(data);
      return data;
    }
    if (!data.requiresWhatsappToken || !data.challengeId) {
      throw new Error("No se pudo iniciar la verificacion de WhatsApp.");
    }
    return data;
  };

  const verifyWhatsapp = async ({ challengeId, code }) => {
    const { data } = await http.post("/auth/verify-whatsapp", { challengeId, code });
    guardarSesion(data);
  };

  const logout = limpiarSesion;

  const value = {
    token,
    usuario,
    autenticado: Boolean(token),
    verificando,
    login,
    verifyWhatsapp,
    logout,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);
